<template>
    <div class="row">
        <div class="col-12 col-md-4">
            <card class="flex-grow-1 card-tasks">
               <span slot="header">
                   <span>Contacts</span>
                   <base-button class="right" type="default" size="sm"
                                @click="showCreateModal = true">+ Add contact</base-button>
               </span>

                <div slot="default">
                    <base-input addon-left-icon="search" placeholder="Search User.." v-model="filter"
                                @input="selectedFirstContact"></base-input>
                    <hr>
                    <p class="text--accent-1 text-center">{{ filteredContacts.length }} result ({{
                        filteredContacts.length }}/{{
                        contacts.length }})</p>

                    <div v-if="status !== 'LOADING'" class="table-full-width table-responsive">
                        <table class="table">
                            <tbody>
                            <tr v-if="contacts" v-for="contact in filteredContacts"
                                v-bind:class="{'active': (selectedContact===contact.id)}"
                                v-on:click.prevent="selectedContact = contact.id">
                                <td>
                                    <p class="info-title">{{ (contact.first_name === null && contact.last_name === null)
                                        ? contact.company : contact.first_name + ' ' + contact.last_name}}</p>
                                    <p class="text-muted">{{ contact.email || contact.company }} | {{ contact.phone_work
                                        ||
                                        contact.phone_mobile
                                        }}</p>
                                </td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                    <div v-if="status === 'LOADING'" class="table-full-width table-responsive">
                        <card>
                            <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                             spin></font-awesome-icon></span></h1>

                        </card>
                    </div>

                </div>
            </card>
        </div>
        <div class="col-12 col-md-8">
            <contact-card :id="selectedContact" v-on:remove="selectedFirstContact"
                          v-on:save="selectedFirstContact"></contact-card>
        </div>
        <new-contact-modal v-on:update-show="updateShow" v-on:created="loadContacts"
                           :show.sync="showCreateModal"></new-contact-modal>
    </div>
</template>

<script>

    import ContactCard from "./ContactCard";
    import {mapFields} from "vuex-map-fields";
    import NewContactModal from "./NewContactModal";

    export default {
        name: "Contacts",
        components: {
            NewContactModal,
            ContactCard
        },
        computed: {
            ...mapFields('contact', ['contacts', 'status']),
            filteredContacts() {
                return this.contacts.filter(contact => {
                    let firstname = contact.first_name != null ? contact.first_name.replace(/\s/g, '').toLowerCase().indexOf(this.filter.replace(/\s/g, '').toLowerCase()) > -1 : false;
                    let lastname = contact.last_name != null ? contact.last_name.replace(/\s/g, '').toLowerCase().indexOf(this.filter.replace(/\s/g, '').toLowerCase()) > -1 : false;
                    let phone_mobile = contact.phone_mobile != null ? contact.phone_mobile.replace(/\s/g, '').toLowerCase().indexOf(this.filter.replace(/\s/g, '').toLowerCase()) > -1 : false;
                    let company = contact.company != null ? contact.company.replace(/\s/g, '').toLowerCase().indexOf(this.filter.replace(/\s/g, '').toLowerCase()) > -1 : false;
                    let email = contact.email != null ? contact.email.replace(/\s/g, '').toLowerCase().indexOf(this.filter.replace(/\s/g, '').toLowerCase()) > -1 : false;
                    let address = contact.address != null ? contact.address.replace(/\s/g, '').toLowerCase().indexOf(this.filter.replace(/\s/g, '').toLowerCase()) > -1 : false;
                    let city = contact.city != null ? contact.city.replace(/\s/g, '').toLowerCase().indexOf(this.filter.replace(/\s/g, '').toLowerCase()) > -1 : false;

                    return !!(firstname || lastname || phone_mobile || company || email || address || city)
                });
            }
        },
        data() {
            return {
                showCreateModal: false,
                selectedContact: 0,
                filter: '',
            };
        },
        methods: {
            loadContacts() {
                this.$store.dispatch('contact/loadContacts').then(() => {
                    this.selectedFirstContact();
                });
            },
            selectedFirstContact() {
                if (this.filteredContacts.length === 0) {
                    this.selectedContact = this.contacts[0].id;
                    this.filter = '';
                }

                this.selectedContact = this.filteredContacts[0].id;
            },
            updateShow(value) {
                this.showCreateModal = value;
            },

        },
        mounted() {
            this.loadContacts();
        }
    }
</script>

<style scoped>
    .active {
        border-radius: 3px !important;
        border: 2px solid #e14eca !important;
        z-index: 10;
        box-shadow: 3px 3px 5px 1px rgba(0, 0, 0, 0.2);
    }

    .card-tasks .table-full-width {
        max-height: 310px;
    }
</style>
